module.exports = __webpack_public_path__ + "img/zh.84911517.svg";